import comp from "./AssessmentGradeScaleToolEdit";
export default comp;
